import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClientService} from '../httpClient/httpclient.service';
import {MessageService} from 'primeng/api';
import {SelfScanService, SelfScanServiceDetail, SelfScanServiceTrx} from '../../models/loyalty-selfScan-service.model';
import {ListMetadata} from '../../models/list-metadata.model';
import {publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class LoyaltySelfscanservicedetailService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(selfscanserviceId, selfscanservicedetailId): Observable <SelfScanServiceDetail> {
    return this.http.get(this.baseUrl + '/self_scanning/services/' + selfscanserviceId + '/detail/' + selfscanservicedetailId);
  }


  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<SelfScanServiceDetail> , metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/self_scanning/services/getServiceDetails?'  + params.toString());

  }

  getFields () {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/SelfScanningServiceDetailDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  // lettura json transazione
  getJson(selfscanservicedetailId): Observable <SelfScanServiceTrx> {
    return this.http.get(this.baseUrl + '/self_scanning/services/details/' + selfscanservicedetailId + '/getTrx' );
  }

  getOneDetail(selfscanservicedetailId): Observable <SelfScanServiceDetail> {
    return this.http.get(this.baseUrl + '/self_scanning/services/getServiceDetails?id=' + selfscanservicedetailId );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-selfscanservicedetail.service.ts